import { MainContentLayout } from 'shared/ui/layout';

import { AddCountry } from 'features/country/add';

export function AddCountryPage() {
  return <MainContentLayout element={<AddCountry />} />;
}
